import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';

const TimePicker = ({ increments = 5, onChange, requireInteraction, value }) => {

    const [time, setTime] = useState(null);
    const [timeOfDay, setTimeOfDay] = useState(null);
    const [times, setTimes] = useState([]);

    const onTimeChange = val => {

        // update local state with time value
        setTime(val);

        // prepare result for listeners and notify of time change
        let next = moment(`${val} ${timeOfDay}`, 'HH:mm');
        if(typeof(onChange) === 'function') {
            onChange(next);
        }
    }

    const onTimeOfDayChange = val => {

        // update local state with time value
        setTimeOfDay(val);

        // prepare result for listeners and notify of time change
        let next = moment(`${time} ${val}`, 'HH:mm a');
        if(typeof(onChange) === 'function') {
            onChange(next);
        }
    }

    const setupTarget = () => {

        // prepare target dates
        let target = value ? moment(value, 'HH:mm a') : moment();

        // set time of day regardless of interaction flag
        let tod = target.format('a');
        setTimeOfDay(tod);

        // prevent date and time set if interaction is required
        if(!value && requireInteraction) {
            return;
        }

        // set time values
        setTime(target.format('h:mm'));
    }

    useEffect(() => {
        let val = (60 / increments) * 12;
        let times = [...new Array(val)].map((_, index) => moment().startOf('day').add(increments * index, 'minutes').format('h:mm'));
        setTimes(times);
    }, [increments]);

    useEffect(() => {
        setupTarget();
    }, [value]);

    return (
        <div
        className={'row p-0 m-0'}
        style={{
            width: '100%'
        }}>
            <div className={'col-12 col-md-6 p-0'}>
                <select
                className={`custom-select ${window.theme}`}
                value={time || 'Time'}
                onChange={e => {
                    let index = Utils.attributeForKey.select(e, 'id');
                    onTimeChange(times[index]);
                }}
                style={{
                    background: `${Appearance.colors.textField()} url("images/custom-select-list-arrows-${window.theme === 'dark' ? 'white' : 'black'}.png") no-repeat right 0.75rem center`,
                    backgroundSize: '10px',
                    color: time ? Appearance.colors.text() : Appearance.colors.subText(),
                    marginRight: 8
                }}>
                    <option disabled={true}>{'Time'}</option>
                    {times.map((time, index) => {
                        return <option key={index} id={index}>{time}</option>
                    })}
                </select>
            </div>
            <div className={'col-12 col-md-6 px-0 pt-1 pb-0 pt-md-0 pl-md-1'}>
                <select
                className={`custom-select ${window.theme}`}
                value={timeOfDay ? timeOfDay.toUpperCase() : 'AM'}
                onChange={e => {
                    let text = Utils.attributeForKey.select(e, 'id');
                    onTimeOfDayChange(text);
                }}
                style={{
                    background: `${Appearance.colors.textField()} url("images/custom-select-list-arrows-${window.theme === 'dark' ? 'white' : 'black'}.png") no-repeat right 0.75rem center`,
                    backgroundSize: '10px'
                }}>
                    <option disabled={true}>{'Time of Day'}</option>
                    {[ 'am', 'pm' ].map((text, index) => {
                        return <option key={index} id={text}>{text.toUpperCase()}</option>
                    })}
                </select>
            </div>
        </div>
    )
}
export default TimePicker;
